import {
    Component,
    OnInit,
    OnDestroy,
    Input,
    ViewChild,
    SimpleChanges
} from "@angular/core";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { CommonService } from "../services/common.service";
import { debounceTime, filter, take, takeUntil } from "rxjs/operators";
import { BehaviorSubject, firstValueFrom, Subject, Subscription } from "rxjs";
import { TabChangeService } from "../services/tab-change.service";
import { NestedTreeControl } from "@angular/cdk/tree";
import { MatTreeNestedDataSource } from "@angular/material/tree";
import { FtpfilesComponent } from "../ftpfiles/ftpfiles.component";
import { ToastrService } from "ngx-toastr";
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from "@angular/forms";
import beautify from "xml-beautifier";
import JSZip from "jszip";
import { ConsolidateviewfileComponent } from 'src/app/consolidateviewfile/consolidateviewfile.component';
import { FileViewExplorerComponent } from 'src/app/file-view-explorer/file-view-explorer.component';
import { NgxEditorModel } from "ngx-monaco-editor-v2";
declare var $

declare const copyToClipboard: any;

@Component({ selector: "app-tryitout", templateUrl: "./tryitout.component.html", styleUrls: ["./tryitout.component.scss"]})
export class TryitoutComponent implements OnInit, OnDestroy {
    @Input() inputDataInModalComponent: any;
    
    // Modal tab management
    private destroy$ = new Subject<void>();
    private tabChangeSubscription: Subscription;
    private componentName = 'try it out';
    private isActiveTab = true;
    private modalWasOpen = false;
    private currentModalRefs: any[] = [];
    private modalRefsTracked: Array<{ ref: any, windowClass: string }> = [];

    private trackModalRef(modalRef: any, windowClass: string = '') {
        this.currentModalRefs.push(modalRef);
        this.modalRefsTracked.push({ ref: modalRef, windowClass });
    }

    private untrackModalRef(modalRef: any) {
        this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== modalRef);
        this.modalRefsTracked = this.modalRefsTracked.filter(m => m.ref !== modalRef);
    }

    inputdata: any;
    pdfviwerflag: boolean=false;
    fitToPage: boolean = true;
    OutputData: string = "";
    formatType: string = "text/plain";
    defaultFormatType:string='text/plain';
    previewDataXMl: boolean = false;
    nestedTreeControl: NestedTreeControl<FileNode>;
    nestedDataSource: MatTreeNestedDataSource<FileNode>;
    private _getChildren = (node: FileNode) => node.children;
    hasNestedChild = (_: number, nodeData: FileNode) => nodeData.children;
    database: FileDatabase;

    editorOptions = {
        theme: 'vs', language: this.defaultFormatType, wordWrap: 'on',scrollBeyondLastLine: false,
        minimap: { enabled: true }
    };

    editorOptions1 = {theme: 'vs', language: this.defaultFormatType,readOnly:true, wordWrap: 'on',scrollBeyondLastLine: false,
        minimap: { enabled: true }
    };
    reactiveFormroutegbl: FormGroup;
    onvaluechange: Subject<string> = new Subject<string>();
    inputdatabackupdata: string;
    fileName: string;

    /** Standalone Try It Out: pipeline (default) or bulk export to TXT */
    tryItOutMode: 'pipeline' | 'export' = 'pipeline';
    private readonly exportTransformApiName = 'api/TransformXml/PostExport';

    exportFiltersForm: FormGroup;
    Vendornamelist: any[] = [];
    VendornameBackuplist: any[] = [];
    exportVendorId = '';
    exportVendorName = '';
    keywordsearchvendar = 'name';
    isLoadingExportVendor = false;
    notfounddataExportVendor = false;

    messageTypeList: any[] = [];
    messageTypeAllList: any[] = [];
    exportMessageType = '';
    exportDirectionOptions = ['Inbound', 'Outbound'];
    keywordsearchmsgtype = 'displayname';
    isLoadingExportMsgType = false;
    notfounddataExportMsgType = false;

    exportLabList: any[] = [];
    exportLabGuid = '';
    exportLabName = '';
    exportLabDeploymentKey = '';
    exportLabEntityType = '';
    keywordsearchLab = 'LocationName';
    isLoadingExportLab = false;
    notfounddataExportLab = false;
    exportLabCustomFilter = (list: any[], _query: string) => list;

    conversionTypeList: any[] = [];
    conversionTypeAllList: any[] = [];
    exportConversionType = '';
    keywordsearchconversion = 'displayname';
    isLoadingExportConversionType = false;
    notfounddataExportConversionType = false;

    isExportInProgress = false;
    exportResolvedProcessors: any[] = [];

    constructor(private ngxUiLoaderService: NgxUiLoaderService, public service: CommonService, private _fb: FormBuilder, public activeModal: NgbActiveModal, private modalService: NgbModal, private toastr: ToastrService, private tabChangeService: TabChangeService) {
        this.nestedTreeControl = new NestedTreeControl<FileNode>(this._getChildren);
        this.nestedDataSource = new MatTreeNestedDataSource();
        this.reactiveFormroutegbl = _fb.group({ routenamegbl: '' });
        this.exportFiltersForm = _fb.group({
            lab: ['', Validators.required],
            accessions: ['', [Validators.required, TryitoutComponent.exportAccessionsValidator]],
            vendorname: ['', Validators.required],
            msgname: ['', Validators.required],
            direction: [{ value: 'Outbound', disabled: true }, Validators.required],
            conversiontypename: ['', Validators.required]
        });
    }

    private static exportAccessionsValidator(control: AbstractControl): ValidationErrors | null {
        const list = (control.value ?? '').toString().split(',').map((s: string) => s.trim()).filter(Boolean);
        if (list.length === 0) {
            return { required: true };
        }
        if (list.length > 10) {
            return { maxAccessions: true };
        }
        return null;
    }
    screeHeightforoutput: number;
    screeHeightforinput: number;
    enableAccessionSearch: boolean = false;
    fileUploadFTP: boolean;
    routedetails: {
        RouteIdtry: any;
        ProcessorIdtry: any;
        ProcessorDisplayNametry: any;
        RouteDisplayNametry: any;
        Processorapikey: any;
        Popupflag: boolean;
        PopupSource?: string;
        MappedXmlTemp: string;
        isFileUpload: boolean;
        isfiledownload: boolean;
        interfacetype: any;
        enableAccessionSearch: boolean;
        fileUploadFTP: boolean;
        sourcedeploymentkey: any;
        targetdeploymentkey: any;
        sourceaccounttype: any;
        targetaccounttype: any;
        seguid: any;
        deguid: any;
        sourceagent: any;
        sourceagentname: any;
    } = {
        RouteIdtry: "",
        ProcessorIdtry: "",
        ProcessorDisplayNametry: "",
        RouteDisplayNametry: "",
        Processorapikey: "",
        Popupflag: false,
        PopupSource: "",
        MappedXmlTemp: "",
        isFileUpload: false,
        isfiledownload: false,
        interfacetype: "",
        enableAccessionSearch: false,
        fileUploadFTP: false,
        sourcedeploymentkey: "",
        targetdeploymentkey: "",
        sourceaccounttype: "",
        targetaccounttype: "",
        seguid: "",
        deguid: "",
        sourceagent: "",
        sourceagentname: ""
    };
    versionDetails: any[];
    versionList: string[] = [];
    version: any;
    selectedVersion: any;
    notfounddata: boolean;
    dynamicJson: routeprocessordata[] = [];
    fileidarray: any[];
    backupfileArray: any[]=[];
    routeMessageType:any;
    isValidationFlag:boolean;
    routeUniqueID: any;
    connectivitytype:string='';
    fileContent: string;
    
    onEditorInit(editor: any) {
        if (editor && editor.updateOptions) {
            editor.updateOptions({
                minimap: { enabled: true }
            });
        }
    }

    onEditorInit1(editor: any) {
        if (editor && editor.updateOptions) {
            editor.updateOptions({
                minimap: { enabled: true }
            });
        }
    }
    
    editorInit(editor) {
        if(editor!==undefined && editor!==''){
                if (this.inputdata) {
                    if (this.inputdata.byteLength > 0) {
                        if (this.OutputData.trim().startsWith("<")) {
                            this.formatType = "xml";
                        } else if (this.OutputData.trim().startsWith("{")) {
                            this.formatType = "json";
                        }
                    }
                    else if (this.inputdata.trim().startsWith("<") || this.OutputData.trim().startsWith("<")) {
                        this.formatType = "xml";
                    } else if (this.inputdata.trim().startsWith("{") || this.OutputData.trim().startsWith("{")) {
                        this.formatType = "json";
                    }
                }
            if(this.defaultFormatType!=this.formatType){
                this.defaultFormatType=this.formatType;
                this.editorOptions = {
                    ...this.editorOptions,
                    language: this.formatType,
                    minimap: { enabled: true }
                };
                this.editorOptions1 = {
                    ...this.editorOptions1,
                    language: this.formatType,
                    readOnly:true,
                    minimap: { enabled: true }
                };
            }
            }
    }

    registerMonacoCustomTheme() {
        monaco.editor.defineTheme("myCustomTheme", {
            base: "vs", // can also be vs or hc-black
            inherit: true, // can also be false to completely replace the builtin rules
            rules: [
                {
                    token: "comment",
                    foreground: "ffa500",
                    fontStyle: "italic underline"
                }, {
                    token: "comment.js",
                    foreground: "008800",
                    fontStyle: "bold"
                }, {
                    token: "comment.css",
                    foreground: "0000ff"
                }, // will inherit fontStyle from `comment` above
            ],
            colors: {}
        });
    }

    classObjalert: string;
    StatusMessage: string;
    transformapiresponse: any[];
    statusmessagetryitout: boolean = false;
    popupflag: boolean = true;
    popupSource: string = "";
    filecheck: boolean;
    senderid: any;
    hash: any;
    transId: any;
    fileidValue: string;
    ngoniniteditorcall:any;
    flag=false;
    async ngOnInit() {
        // Subscribe to tab changes
        this.tabChangeSubscription = this.tabChangeService.tabChange$.pipe(
            takeUntil(this.destroy$)
        ).subscribe((tabName: string) => {
            this.isActiveTab = tabName.toLowerCase() === this.componentName.toLowerCase();
            setTimeout(() => {
                if (this.isActiveTab) {
                    this.showModals();
                } else {
                    this.hideModals();
                }
            }, 0);
        });
        
        this.screeHeightforoutput = window.innerHeight - 250;
        this.screeHeightforinput = window.innerHeight - 281;
        if (this.inputDataInModalComponent != undefined) {
            if (this.inputDataInModalComponent) {
                this.routedetails.RouteIdtry = this.inputDataInModalComponent.RouteIdtry || "";
                this.routedetails.ProcessorIdtry = this.inputDataInModalComponent.ProcessorIdtry || "";
                this.popupflag = this.inputDataInModalComponent.Popupflag;
                this.popupSource = this.inputDataInModalComponent.PopupSource || (this.popupflag ? "create" : "");
                this.isValidationFlag = this.inputDataInModalComponent.isValidationFlag;
                this.fileUploadFTP = this.inputDataInModalComponent.fileUploadFTP;
                this.enableAccessionSearch = this.inputDataInModalComponent.enableAccessionSearch;
                if (this.enableAccessionSearch || this.fileUploadFTP || (this.inputDataInModalComponent.showVersionDetails != undefined && this.inputDataInModalComponent.showVersionDetails)) {
                    this.screeHeightforinput = window.innerHeight - 289;
                }

                if (this.inputDataInModalComponent.RouteIdtry && this.inputDataInModalComponent.ProcessorIdtry) {
                    this.selectedrouteIdgbl = this.inputDataInModalComponent.RouteIdtry;
                    this.getRouteDetails();
                }
            }
        } else {
            this.fileUploadFTP = false;
            this.enableAccessionSearch = false;
            this.inputDataInModalComponent = <any>[];
            this.inputDataInModalComponent.RouteDisplayNametry = "";
            this.inputDataInModalComponent.ProcessorDisplayNametry = "";
            this.inputDataInModalComponent.RouteIdtry = "";
            this.inputDataInModalComponent.ProcessorIdtry = "";
            this.popupflag = false;
            this.popupSource = "";
            this.routedetails.MappedXmlTemp = "";
            this.routedetails.RouteIdtry = "";
            this.routedetails.ProcessorIdtry = "";
            if(this.inputDataInModalComponent.selectedfilecontent!=undefined || this.inputDataInModalComponent.selectedfilecontent!='')
            {
                this.inputdata=this.inputDataInModalComponent.selectedfilecontent;
            }
        }
        // this.editorInit(this.ngoniniteditorcall);
        this.flag=true;
    }
    isValuefromInput: boolean = false;
    ngOnChanges() {
        if (!this.inputDataInModalComponent) {
            this.isValuefromInput = true;
        } else {
            this.isValuefromInput = false;
        }
    }

    onTryItOutModeChange() {
        // Export mode exists only for standalone (non-modal) usage.
        if (this.inputDataInModalComponent) return;
        if (this.tryItOutMode !== 'export') return;

        this.syncExportDirectionField();

        // Lazily load autocomplete lists when the user switches to Export.
        if (!this.Vendornamelist || this.Vendornamelist.length === 0) {
            this.loadExportVendorNames();
        }
        if (!this.messageTypeList || this.messageTypeList.length === 0) {
            this.getExportMessagetypelist('msgtype');
        }
    }

    // ----------------------------
    // Export mode: vendor autocomplete
    // ----------------------------
    loadExportVendorNames() {
        this.isLoadingExportVendor = true;
        this.notfounddataExportVendor = false;

        const url = "api/Vendor/GetVendorName";
        this.service.getapiurl(url).subscribe({
            next: (data) => {
                this.Vendornamelist = (data as any[]) || [];
                this.Vendornamelist = this.service.transformAlphabetically(this.Vendornamelist, 'name');
                this.VendornameBackuplist = this.Vendornamelist;
                this.isLoadingExportVendor = false;
                this.notfounddataExportVendor = this.Vendornamelist.length === 0;
            },
            error: () => {
                this.isLoadingExportVendor = false;
                this.notfounddataExportVendor = true;
            }
        });
    }

    selectedExportVendor(item: any) {
        this.exportVendorName = item?.name || '';
        this.exportVendorId = item?.Id || '';
        this.exportResolvedProcessors = [];
        this.clearResolvedConversionTypes();
        this.exportFiltersForm.patchValue({ vendorname: this.exportVendorName });
        this.notfounddataExportVendor = false;
    }

    searchExportVendorCleared(_: any) {
        this.exportVendorId = '';
        this.exportVendorName = '';
        this.exportResolvedProcessors = [];
        this.clearResolvedConversionTypes();
        this.Vendornamelist = this.VendornameBackuplist || [];
        this.notfounddataExportVendor = false;
        this.exportFiltersForm.patchValue({ vendorname: '' });
    }

    getExportVendorName(event: any) {
        const val = (event ?? '').toString();
        this.isLoadingExportVendor = false;

        if (!this.VendornameBackuplist || this.VendornameBackuplist.length === 0) {
            // If lists aren't loaded yet, load them on-demand.
            this.loadExportVendorNames();
            return;
        }

        if (!val) {
            this.Vendornamelist = this.VendornameBackuplist;
            this.notfounddataExportVendor = false;
            return;
        }

        this.Vendornamelist = this.VendornameBackuplist.filter(t =>
            (t?.name || '').toLowerCase().includes(val.toLowerCase())
        );
        this.notfounddataExportVendor = this.Vendornamelist.length === 0;
    }

    // ----------------------------
    // Export mode: message type autocomplete
    // ----------------------------
    async getExportMessagetypelist(event: any) {
        this.isLoadingExportMsgType = true;
        this.notfounddataExportMsgType = false;

        if (event === 'msgtype') {
            try {
                const data = await firstValueFrom(
                    this.service.getapiurl("api/Lookup/GetMessageType?lookuptype=messagetype")
                );
                const list = (data as any[]) || [];
                this.messageTypeAllList = list.map((element: any) => ({ displayname: element }));
                this.messageTypeList = this.messageTypeAllList;
                this.isLoadingExportMsgType = false;
                this.notfounddataExportMsgType = this.messageTypeList.length === 0;
                return;
            } catch {
                this.isLoadingExportMsgType = false;
                this.notfounddataExportMsgType = true;
                return;
            }
        }

        const val = (event ?? '').toString();
        if (!this.messageTypeAllList || this.messageTypeAllList.length === 0) {
            // If user starts typing before lists loaded, load them first.
            await this.getExportMessagetypelist('msgtype');
            // Now filter using current val.
        }

        if (!val) {
            this.messageTypeList = this.messageTypeAllList || [];
            this.notfounddataExportMsgType = this.messageTypeList.length === 0;
            this.isLoadingExportMsgType = false;
            return;
        }

        this.messageTypeList = (this.messageTypeAllList || []).filter(t =>
            (t?.displayname || '').toLowerCase().includes(val.toLowerCase())
        );
        this.notfounddataExportMsgType = this.messageTypeList.length === 0;
        this.isLoadingExportMsgType = false;
    }

    get showExportDirectionSelect(): boolean {
        return this.isResultExportMessageType(this.exportMessageType);
    }

    private isResultExportMessageType(messageType: string): boolean {
        const val = (messageType || '').trim().toLowerCase();
        return val === 'result' || val === 'results';
    }

    private syncExportDirectionField(): void {
        const directionCtrl = this.exportFiltersForm.get('direction');
        if (!directionCtrl) {
            return;
        }
        if (this.isResultExportMessageType(this.exportMessageType)) {
            directionCtrl.enable({ emitEvent: false });
            if (!directionCtrl.value) {
                directionCtrl.setValue('Outbound', { emitEvent: false });
            }
        } else {
            directionCtrl.setValue('Outbound', { emitEvent: false });
            directionCtrl.disable({ emitEvent: false });
        }
    }

    onExportDirectionChange(): void {
        this.exportResolvedProcessors = [];
        this.clearResolvedConversionTypes();
    }

    selectedExportMessageType(item: any) {
        this.exportMessageType = item?.displayname || '';
        this.exportFiltersForm.patchValue({ msgname: this.exportMessageType });
        this.syncExportDirectionField();
        this.exportResolvedProcessors = [];
        this.clearResolvedConversionTypes();
        this.notfounddataExportMsgType = false;
    }

    clearExportMessageType(_: any) {
        this.exportMessageType = '';
        this.messageTypeList = this.messageTypeAllList || [];
        this.exportFiltersForm.patchValue({ msgname: '' });
        this.syncExportDirectionField();
        this.exportResolvedProcessors = [];
        this.clearResolvedConversionTypes();
        this.notfounddataExportMsgType = false;
    }

    // ----------------------------
    // Export mode: Lab (source entity) autocomplete
    // ----------------------------
    exportLocationString(item: string, item1: string, item2: string) {
        const names = item2.split('(');
        item2 = names[2] !== 'null)' && names[2] !== undefined
            ? `${names[0]} <br> (${names[1]} <br> (${names[2]}`
            : `${names[0]} <br> (${names[1]}`;
        return '(' + item + ')' + ' ' + item1 + ' : ' + item2;
    }

    getExportLabNames(event: any) {
        let valuesa = (event ?? '').toString();
        if (valuesa.includes(':')) {
            const splitValues = valuesa.split(':');
            if (splitValues.length === 2) {
                splitValues[1] = ' ' + splitValues[1].trimStart();
                valuesa = splitValues.join(':');
            }
            if (splitValues.length === 3) {
                splitValues[1] = ' ' + splitValues[1].trimStart();
                splitValues[2] = ' ' + splitValues[2].trimStart();
                valuesa = splitValues.join(':');
            }
        }
        this.exportLabGuid = '';
        this.exportFiltersForm.patchValue({ lab: valuesa });
        if (valuesa !== '' && !valuesa.endsWith(':') && !valuesa.endsWith(': ')) {
            const valueToSendToApiWithOutWhiteSpace = valuesa.replaceAll(': ', ':');
            this.isLoadingExportLab = true;
            const obj = {
                lSearch: valueToSendToApiWithOutWhiteSpace,
                LocationGUID: '',
                deploymentkey: '',
                associatedaccountids: ''
            };
            this.service.GetAccountNamesListAsync(obj).subscribe({
                next: (response: any) => {
                    if (response?.status && response?.statusText) {
                        this.exportLabList = [];
                        this.notfounddataExportLab = true;
                        this.isLoadingExportLab = false;
                        this.toastr.error('Unable to fetch Lab details', '', {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });
                    } else if (response?.length > 0) {
                        this.exportLabList = this.service.transformAlphabetically(response, 'LocationName');
                        this.exportLabList = this.exportLabList.map((row: any) => ({
                            ...row,
                            LocationName: row.UniqueID != null && row.UniqueID !== undefined
                                ? `${row.LocationName} (${row.LocationGUID}) (${row.UniqueID})`
                                : `${row.LocationName} (${row.LocationGUID})`
                        }));
                        this.notfounddataExportLab = false;
                    } else {
                        this.exportLabList = [];
                        this.notfounddataExportLab = true;
                    }
                    this.exportLabGuid = '';
                    this.isLoadingExportLab = false;
                },
                error: () => {
                    this.exportLabList = [];
                    this.notfounddataExportLab = true;
                    this.isLoadingExportLab = false;
                }
            });
        } else {
            this.exportLabList = [];
            this.notfounddataExportLab = true;
        }
    }

    selectedExportLab(item: any) {
        this.exportLabGuid = item?.LocationGUID || '';
        this.exportLabName = item?.LocationName || '';
        this.exportLabDeploymentKey = item?.deploymentkey || '';
        this.exportLabEntityType = item?.Type || '';
        this.exportFiltersForm.patchValue({ lab: item?.LocationName || '' });
        this.notfounddataExportLab = false;
    }

    searchExportLabCleared(_: any) {
        this.isLoadingExportLab = false;
        this.exportLabList = [];
        this.exportLabGuid = '';
        this.exportLabName = '';
        this.exportLabDeploymentKey = '';
        this.exportLabEntityType = '';
        this.notfounddataExportLab = false;
        this.exportFiltersForm.patchValue({ lab: '' });
    }

    // ----------------------------
    // Export mode: conversion type autocomplete
    // ----------------------------
    private clearResolvedConversionTypes() {
        this.exportConversionType = '';
        this.conversionTypeAllList = [];
        this.conversionTypeList = [];
        this.exportFiltersForm.patchValue({ conversiontypename: '' });
        this.notfounddataExportConversionType = false;
    }

    private setConversionTypesFromValues(values: string[]) {
        const normalized = values
            .map(v => (v || '').toString().trim())
            .filter(Boolean);
        const unique = Array.from(new Set(normalized.map(x => x.toLowerCase())))
            .map(lower => normalized.find(v => v.toLowerCase() === lower) as string);
        this.conversionTypeAllList = unique.map(x => ({ displayname: x }));
        this.conversionTypeList = [...this.conversionTypeAllList];
        this.notfounddataExportConversionType = this.conversionTypeAllList.length === 0;
    }

    get showExportConversionTypeField(): boolean {
        return (this.conversionTypeAllList?.length || 0) > 1;
    }

    private async getExportTemplatesForSelection(conversionType?: string): Promise<any[]> {
        const searchData: any = {
            templateid: '',
            messagetype: this.exportMessageType,
            direction: this.exportFiltersForm.getRawValue().direction || 'Outbound',
            vendor: this.exportVendorId,
            isactive: true
        };
        if (conversionType) {
            searchData.conversiontype = conversionType;
        }
        const response: any = await this.service.searchpostapi('api/GetMappings/SearchTemplates', searchData);
        return Array.isArray(response) ? response : [];
    }

    async getExportConversionTypelist(event: any) {
        if (event === 'conversiontype') return;
        this.isLoadingExportConversionType = true;
        const val = (event ?? '').toString();
        if (!val) {
            this.conversionTypeList = this.conversionTypeAllList || [];
        } else {
            this.conversionTypeList = (this.conversionTypeAllList || []).filter(t =>
                (t?.displayname || '').toLowerCase().includes(val.toLowerCase())
            );
        }
        this.notfounddataExportConversionType = this.conversionTypeList.length === 0;
        this.isLoadingExportConversionType = false;
    }

    selectedExportConversionType(item: any) {
        this.exportConversionType = item?.displayname || '';
        this.exportFiltersForm.patchValue({ conversiontypename: this.exportConversionType });
        this.notfounddataExportConversionType = false;
    }

    clearExportConversionType(_: any) {
        this.exportConversionType = '';
        this.conversionTypeList = this.conversionTypeAllList || [];
        this.exportFiltersForm.patchValue({ conversiontypename: '' });
        this.notfounddataExportConversionType = false;
    }

    // ----------------------------
    // Export mode: validation & export TXT
    // ----------------------------
    private parseExportAccessions(): string[] {
        const raw = this.exportFiltersForm?.get('accessions')?.value ?? '';
        const list = raw
            .split(',')
            .map(s => s.trim())
            .filter(Boolean);
        // Keep order but remove duplicates.
        const seen = new Set<string>();
        return list.filter(x => {
            const key = x.toLowerCase();
            if (seen.has(key)) return false;
            seen.add(key);
            return true;
        });
    }

    private validateExportFilters(): { ok: boolean; accessions?: string[]; error?: string } {
        this.exportFiltersForm.markAllAsTouched();
        const accessions = this.parseExportAccessions();

        if (!this.exportLabGuid) {
            return { ok: false, error: 'Lab is required' };
        }
        if (!this.exportVendorId) {
            return { ok: false, error: 'Vendor is required' };
        }
        if (!this.exportMessageType) {
            return { ok: false, error: 'Message Type is required' };
        }
        if (this.exportFiltersForm.get('accessions')?.hasError('maxAccessions')) {
            return { ok: false, error: 'Maximum 10 accession numbers allowed' };
        }
        if (this.exportFiltersForm.invalid) {
            const conversionMissing = !this.exportConversionType;
            if (conversionMissing) {
                return { ok: true, accessions };
            }
            if (accessions.length === 0) {
                return { ok: false, error: 'At least one accession number is required' };
            }
            return { ok: false, error: 'Please fill all required export fields' };
        }
        return { ok: true, accessions };
    }

    resetExportFilters() {
        this.exportLabGuid = '';
        this.exportLabName = '';
        this.exportLabDeploymentKey = '';
        this.exportLabEntityType = '';
        this.exportVendorId = '';
        this.exportVendorName = '';
        this.exportMessageType = '';
        this.exportConversionType = '';
        this.exportResolvedProcessors = [];

        this.notfounddataExportLab = false;
        this.notfounddataExportVendor = false;
        this.notfounddataExportMsgType = false;
        this.notfounddataExportConversionType = false;

        this.exportLabList = [];
        this.Vendornamelist = this.VendornameBackuplist || [];
        this.messageTypeList = this.messageTypeAllList || [];
        this.conversionTypeAllList = [];
        this.conversionTypeList = [];

        this.exportFiltersForm.reset({
            lab: '',
            accessions: '',
            vendorname: '',
            msgname: '',
            direction: 'Outbound',
            conversiontypename: ''
        });
        this.syncExportDirectionField();
    }

    private async transformExportInputToTransformedData(
        inputData: string,
        ctx: {
            processorId?: string;
            apiKey?: string;
            processorUrl?: string;
            generatedXsl?: string;
            conversionType?: string;
            isFileUpload?: boolean;
            isFileDownload?: boolean;
            fileUploadUrl?: string;
            fileDownloadUrl?: string;
            version?: string;
            sourceAgentId?: string;
            deploymentKey?: string;
        }
    ): Promise<{ ok: boolean; transformedData?: string; error?: string }> {
        if (!ctx?.processorId || !ctx?.apiKey || !ctx?.processorUrl) {
            return { ok: false, error: "Transform processor context is not available for this accession" };
        }
        if (!ctx?.generatedXsl) {
            return { ok: false, error: "Template XSL is required for export transform" };
        }

        const apiname = this.exportTransformApiName;
        const jsonpost = {
            "InputData": inputData,
            "ProcessorId": ctx.processorId,
            "ApiKey": ctx.apiKey,
            "ProcessorUrl": ctx.processorUrl,
            "ConversionType": ctx.conversionType || this.exportConversionType,
            "GeneratedXsl": ctx.generatedXsl,
            "IsFileUpload": !!ctx.isFileUpload,
            "IsFileDownload": !!ctx.isFileDownload,
            "FileUploadUrl": ctx.fileUploadUrl || '',
            "FileDownloadUrl": ctx.fileDownloadUrl || '',
            "Version": ctx.version || '',
            "SourceAgentId": ctx.sourceAgentId || '',
            "DeploymentKey": ctx.deploymentKey || '',
        };

        try {
            const response = await this.service.postapi(apiname, jsonpost);
            if (!response || response.length === 0) {
                return { ok: false, error: "Transform failed (empty response)" };
            }

            if ((response[0]["status"] && response[0]["statusText"]) || response[0]["statusmessage"] == null) {
                const err = response[0]["statusmessage"] || "Transform failed";
                return { ok: false, error: err };
            }

            const raw = response[0]["responsebody"];
            if (!raw) return { ok: false, error: "Transform failed (no responsebody)" };

            let output = this.service.applyTimezoneToResponseBody(raw);
            if (output.match(/\||^[^\/<>\\].*$/)) {
                output = this.formatHL7(output);
            } else {
                output = this.formatXml(output);
            }
            return { ok: true, transformedData: output };
        } catch (e: any) {
            return { ok: false, error: e?.message || "Transform failed" };
        }
    }

    private normalizeMessageType(messageType: string): string {
        const val = (messageType || '').toLowerCase();
        if (val === 'result') return 'Results';
        if (val === 'order') return 'Orders';
        if (val === 'dft' || val === 'vcdft') return 'dft';
        return messageType;
    }

    private mapExportEntityType(entityType: string): string {
        const val = (entityType || '').trim().toUpperCase();
        if (val === 'A') return 'account';
        if (val === 'O') return 'organization';
        return entityType || '';
    }

    private async fetchExportProcessorsByConversionType(conversionType: string): Promise<any[]> {
        const messageType = this.exportMessageType || '';
        const interfaceType = this.exportFiltersForm.getRawValue().direction || 'Outbound';
        const apiName = `api/CoreConfig/GetExportProcessorsByConversionType?messageType=${encodeURIComponent(messageType)}&interfaceType=${encodeURIComponent(interfaceType)}&conversionType=${encodeURIComponent(conversionType)}`;
        const data = await firstValueFrom(this.service.getapiurl(apiName));
        return Array.isArray(data) ? data : [];
    }

    private async getExportTemplate(): Promise<any> {
        const list = await this.getExportTemplatesForSelection(this.exportConversionType);
        return list.length > 0 ? list[0] : null;
    }

    private async getExportSourceAgentIdFromDeployment(): Promise<string> {
        if (!this.exportLabDeploymentKey) {
            return '';
        }
        try {
            const configApi = "api/CoreConfig/GetProcessorUIConfig?agentid=&apikey=";
            const responseConfig: any = await this.service.getapi(configApi);
            const configs = JSON.parse(responseConfig?.responsebody || '{}');
            const dpconfig = configs[this.exportLabDeploymentKey];
            return (dpconfig?.SA || '').toString().trim();
        } catch {
            return '';
        }
    }

    private async getExportInputXmlByAccession(accession: string): Promise<{ ok: boolean; xml?: string; error?: string }> {
        if (!this.exportLabDeploymentKey) {
            return { ok: false, error: 'Selected lab deployment key is not available' };
        }
        const configApi = "api/CoreConfig/GetProcessorUIConfig?agentid=&apikey=";
        const responseConfig: any = await this.service.getapi(configApi);
        const configs = JSON.parse(responseConfig?.responsebody || '{}');
        const dpconfig = configs[this.exportLabDeploymentKey];
        if (!dpconfig?.apidetails?.headers || !dpconfig?.apidetails?.inputxmlapiurl) {
            return { ok: false, error: 'Input XML API configuration is not available for selected lab' };
        }
        const obj = {
            Accessionnumber: accession,
            EntityType: this.mapExportEntityType(this.exportLabEntityType),
            EntityValue: this.exportLabGuid || '',
            MessageType: this.normalizeMessageType(this.exportMessageType),
            Headers: JSON.stringify(dpconfig.apidetails["headers"]),
            Url: dpconfig.apidetails["inputxmlapiurl"],
            collectsourceagentflag: false
        };
        const dxresponse: any = await this.service.postapi("api/TransformXml/GetInputXML", obj);
        if (!dxresponse || !dxresponse['responsemessage']) {
            return { ok: false, error: 'No data found' };
        }
        if (!dxresponse['xml'] && dxresponse['responsemessage']) {
            return { ok: false, error: dxresponse['responsemessage'] || 'No XML returned' };
        }
        if (dxresponse['responsemessage'] && dxresponse['xml']) {
            return { ok: true, xml: dxresponse['xml'] };
        }
        return { ok: false, error: 'No data found' };
    }

    private getExportDateStamp(): string {
        return new Date().toISOString().replace(/[:.]/g, '-');
    }

    private sanitizeExportFileSegment(value: string): string {
        return (value || 'unknown')
            .trim()
            .replace(/[<>:"/\\|?*\x00-\x1F]/g, '_')
            .replace(/\s+/g, '_')
            .substring(0, 80) || 'unknown';
    }

    private buildExportAccessionFileName(accession: string): string {
        return `${this.sanitizeExportFileSegment(accession)}.txt`;
    }

    private showExportAccessionSuccessToast(accession: string): void {
        this.toastr.success(`Export succeeded for accession ${accession}`, '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right'
        });
    }

    private showExportAccessionFailureToast(accession: string, reason: string): void {
        this.toastr.error(`Export failed for accession ${accession}: ${reason}`, '', {
            timeOut: 5000,
            positionClass: 'toast-bottom-right'
        });
    }

    private async downloadExportZip(
        files: { filename: string; content: string }[],
        zipFileName: string
    ): Promise<void> {
        if (!files.length) {
            return;
        }
        const zip = new JSZip();
        const usedNames = new Set<string>();
        for (const file of files) {
            let name = file.filename;
            let suffix = 1;
            while (usedNames.has(name)) {
                const base = file.filename.replace(/\.txt$/i, '');
                name = `${base}_${suffix}.txt`;
                suffix++;
            }
            usedNames.add(name);
            zip.file(name, file.content);
        }
        const blob = await zip.generateAsync({ type: 'blob' });
        const FileSaver = require('file-saver');
        FileSaver.saveAs(blob, zipFileName);
    }

    async exportTryItOutData() {
        if (this.isExportInProgress) return;
        const validation = this.validateExportFilters();
        if (!validation.ok || !validation.accessions) {
            this.toastr.warning(validation.error || "Invalid input", "", {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
            });
            return;
        }

        const accessions = validation.accessions;
        this.isExportInProgress = true;
        this.ngxUiLoaderService.start();

        const exportFiles: { filename: string; content: string }[] = [];
        const dateStamp = this.getExportDateStamp();
        try {
            if (!this.exportConversionType) {
                const templates = await this.getExportTemplatesForSelection();
                if (!templates.length) {
                    this.toastr.warning("No templates found for selected vendor, message type and direction", "", {
                        timeOut: 4000,
                        positionClass: 'toast-bottom-right'
                    });
                    return;
                }
                const conversionTypes = templates
                    .map((t: any) => (t?.conversiontype || '').toString().trim())
                    .filter((x: string) => !!x);

                if (!conversionTypes.length) {
                    this.setConversionTypesFromValues([]);
                    this.toastr.warning("For selected vendor and message type, conversion type is not configured in template table", "", {
                        timeOut: 5000,
                        positionClass: 'toast-bottom-right'
                    });
                    return;
                }

                this.setConversionTypesFromValues(conversionTypes);
                if (this.conversionTypeAllList.length === 1) {
                    this.exportConversionType = this.conversionTypeAllList[0].displayname;
                    this.exportFiltersForm.patchValue({ conversiontypename: this.exportConversionType });
                } else {
                    this.toastr.warning("Select Conversion Type and click Export again", "", {
                        timeOut: 4000,
                        positionClass: 'toast-bottom-right'
                    });
                    return;
                }
            }

            this.exportResolvedProcessors = await this.fetchExportProcessorsByConversionType(this.exportConversionType);
            if (!this.exportResolvedProcessors.length) {
                this.toastr.warning("No processor configuration found for selected conversion type", "", {
                    timeOut: 4000,
                    positionClass: 'toast-bottom-right'
                });
                return;
            }
            if (this.exportResolvedProcessors.length > 1) {
                this.toastr.info("Multiple processor configs found. Using the latest active processor.", "", {
                    timeOut: 4000,
                    positionClass: 'toast-bottom-right'
                });
            }
            const selectedProcessor = this.exportResolvedProcessors[0];

            const selectedTemplate = await this.getExportTemplate();
            const generatedXsl = selectedTemplate?.xslt || '';
            if (!generatedXsl) {
                this.toastr.error("Template XSL is required for export transform", "", {
                    timeOut: 4000,
                    positionClass: 'toast-bottom-right'
                });
                return;
            }

            const exportSourceAgentId = await this.getExportSourceAgentIdFromDeployment();

            for (let i = 0; i < accessions.length; i++) {
                const acc = accessions[i];
                const fileName = this.buildExportAccessionFileName(acc);

                const inputXml = await this.getExportInputXmlByAccession(acc);
                if (!inputXml.ok || !inputXml.xml) {
                    this.showExportAccessionFailureToast(
                        acc,
                        inputXml.error || 'No input data returned'
                    );
                    continue;
                }

                const transformed = await this.transformExportInputToTransformedData(inputXml.xml, {
                    processorId: selectedProcessor?.processorid,
                    apiKey: selectedProcessor?.apikey,
                    processorUrl: selectedProcessor?.processorurl,
                    generatedXsl: generatedXsl,
                    conversionType: this.exportConversionType,
                    isFileUpload: !!selectedProcessor?.isfileupload,
                    isFileDownload: !!selectedProcessor?.isfiledownload,
                    fileUploadUrl: selectedProcessor?.fileuploadurl,
                    fileDownloadUrl: selectedProcessor?.filedownloadurl,
                    version: selectedProcessor?.version,
                    sourceAgentId: exportSourceAgentId,
                    deploymentKey: this.exportLabDeploymentKey
                });

                if (!transformed.ok) {
                    this.showExportAccessionFailureToast(
                        acc,
                        transformed.error || 'Transform failed'
                    );
                    continue;
                }

                exportFiles.push({
                    filename: fileName,
                    content: transformed.transformedData || ''
                });
                this.showExportAccessionSuccessToast(acc);
            }

            if (!exportFiles.length) {
                return;
            }

            const zipFileName = `TryItOut_Export_${dateStamp}.zip`;
            await this.downloadExportZip(exportFiles, zipFileName);
        } catch (e: any) {
            this.toastr.error(e?.message || "Export failed", "", {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
            });
        } finally {
            this.ngxUiLoaderService.stop();
            this.isExportInProgress = false;
        }
    }
    getstringRoute(value) {
        let names = value.split("(")
        value = `${names[0]} <br>(${names[1]} <br>(${names[2]}`
        return value
    }
    searchkey: string = "";
    GetxmlByAccessionNumber() {
        this.inputdata = "";
        this.OutputData = "";
        if (this.searchkey) {

            let isvalid = false;
            if (this.searchkey.indexOf(',') > -1) {
                //isvalid = true;
                this.toastr.warning("Multiple Accession Search is not supported!", "", {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
            });
            
            }
            else if (this.searchkey.split(',').length <= 5) {
                isvalid = true;
            }
            if (isvalid) {
                let dpkey = this.routedetails?.sourcedeploymentkey || '';

                this.ngxUiLoaderService.start();
                var apiname = "api/CoreConfig/GetProcessorUIConfig?agentid=&apikey=";
                this.service.getapi(apiname).then(responseconfig => {
                    ;
                    var configs = JSON.parse(responseconfig.responsebody);
                    var dpconfig = configs[dpkey];
                    //  this.getdeploymentconfiguration().then(response=>{
                    /* Get the message type from processor  */
                    var searchData = {
                        "id": this.routedetails.ProcessorIdtry,
                        "type": "Processor"
                    };
                    var messagetype = "";
                    var apiname = 'api/Agents/GetSearchDetails';
                    this.service.searchpostapi(apiname, searchData).then(responseagent => {
                        const resultset = responseagent as any[];
                        var processoragentconfigdata;
                        if (resultset[0]["jsonconfig"]) {
                            var jsonconfig = JSON.parse(resultset[0]["jsonconfig"]);
                            processoragentconfigdata = jsonconfig.processoragentconfig;
                            if (processoragentconfigdata != undefined) {
                                if (processoragentconfigdata.messagetype) {
                                    messagetype = processoragentconfigdata.messagetype;
                                }
                            }
                        }
                        if (messagetype.toLowerCase() == 'result') {
                            messagetype = "Results";
                        } else if (messagetype.toLowerCase() == 'order') {
                            messagetype = "Orders";
                        }
                        else if (messagetype.toLowerCase() == 'dft'|| messagetype.toLowerCase() == 'vcdft')
                        {
                            messagetype="dft"
                        }
                        else if (messagetype.toLowerCase() == 'vcdft')
                        {
                            messagetype="vcdft"
                        }
                        var EntityType = '';
                        var EntityValue = '';
                        let isEmptyAccounttype = false;
                        if (this.routedetails && this.routedetails.sourceaccounttype === "") {
                            this.ngxUiLoaderService.stop();
                            this.toastr.error("Account type of the Source entity is not available" , "", {
                                timeOut: 4000,
                                positionClass: 'toast-bottom-right'
                            });
                            isEmptyAccounttype = true;
                        }
                        else if (this.routedetails && this.routedetails.targetaccounttype === "") {
                            this.ngxUiLoaderService.stop();
                            this.toastr.error("Account type of the Destination entity is not available", "", {
                                timeOut: 4000,
                                positionClass: 'toast-bottom-right'
                            });
                            isEmptyAccounttype = true;
                        }
                        if (!isEmptyAccounttype) {
                          this.ngxUiLoaderService.start();
                            if ((this.inputDataInModalComponent != undefined && (this.inputDataInModalComponent.interfacetype === "Outbound" || this.inputDataInModalComponent.interfacetype === "EllkayResultOutbound")) || (this.routedetails != undefined && (this.routedetails.interfacetype === "Outbound" || this.routedetails.interfacetype === "EllkayResultOutbound"))) {
                                EntityType = this.routedetails.sourceaccounttype;
                                EntityValue = this.routedetails.seguid;
                            } else {
                                EntityType = this.routedetails.sourceaccounttype;
                                EntityValue = this.routedetails.seguid;
                            }
                            var inputsearch = {
                                "AccessionnumberList": this.searchkey.split(','),
                                "EntityType": EntityType,
                                "EntityValue": EntityValue,
                                "MessageType": messagetype,
                                "Headers": JSON.stringify(dpconfig.apidetails["headers"]),
                                "Url": dpconfig.apidetails["inputxmlapiurl"],
                                "collectsourceagentflag": !!(this.inputDataInModalComponent && this.inputDataInModalComponent.collectsourceagentflag === true)
                            }
                            this.getcasexml(inputsearch);

                        }
                    });
                });

            }
            // else{
            //     this.toastr.warning("Please provide upto 5 accession number!!", "", {
            //         timeOut: 4000,
            //         positionClass: 'toast-bottom-right'
            //     });
            // }
        }
        else {
            this.toastr.warning("Please enter the accession number!!", "", {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
            });
        }

    }
    inputxml = [];
    getcasexml(input) {
        this.inputxml = [];
        let counter = 0;
        for (let i = 0; i < input.AccessionnumberList.length; i++) {

            let obj = {
                "Accessionnumber": input.AccessionnumberList[i],
                "EntityType": input.EntityType,
                "EntityValue": input.EntityValue,
                "MessageType": input.MessageType,
                "Headers": input.Headers,
                "Url": input.Url,
                "collectsourceagentflag": input["collectsourceagentflag"] === true
            }
            this.service.postapi("api/TransformXml/GetInputXML", obj).then(dxresponse => {

                if (!dxresponse || !dxresponse['responsemessage']) {
                    this.ngxUiLoaderService.stop();
                    this.toastr.warning("No data found", "", {
                        timeOut: 4000,
                        positionClass: 'toast-bottom-right'
                        });
                    
                }
                else if (!dxresponse['xml'] && dxresponse['responsemessage']) {
                    this.ngxUiLoaderService.stop();
                    this.inputdata = dxresponse['responsemessage'];
                }
                else if (dxresponse['responsemessage'] && dxresponse['xml']) {

                        this.inputdata = dxresponse["xml"];
                        //this.searchkey = "";
                        this.ngxUiLoaderService.stop();
                    
                } else {
                    this.ngxUiLoaderService.stop();
                    this.toastr.warning("Not data found", "", {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });
                    this.searchkey = "";
                }                
            });

        }

    }
    async getdeploymentconfiguration() {
        var dpkey = '';
        // if ((this.inputDataInModalComponent != undefined && this.inputDataInModalComponent.interfacetype === "Inbound") || (this.routedetails != undefined && this.routedetails.interfacetype === "Inbound")) {
        //     dpkey = this.inputDataInModalComponent == "" ? this.routedetails.targetdeploymentkey : this.inputDataInModalComponent.targetdeploymentkey;
        // } else


    }


    async validatedata() {
        if (this.routedetails.RouteIdtry == "") {
            this.toastr.warning("Pipeline is mandatory", "", {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
            });
            return false;
        } else if (this.routedetails.ProcessorIdtry == "") {

            this.toastr.warning("Processor is mandatory", "", {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
            });
            return false;
        } else {
            return true;
        }
    }
    async Transformdata(InputDatacontentvalue) {
        var apiname = "api/TransformXml/Post";
        let inputarray = [];
        if (InputDatacontentvalue) {
            if (Array.isArray(InputDatacontentvalue) && InputDatacontentvalue.length > 0) {
                inputarray = InputDatacontentvalue;
            }
            else {
                if (this.pdfviwerflag) {
                    InputDatacontentvalue=this.inputdatabackupdata;
                    inputarray.push(InputDatacontentvalue)
                }
                else{
                    inputarray.push(InputDatacontentvalue);
                }
            }
        }
        if (inputarray.length > 0) {
            if (this.validatexml(inputarray)) {
                const jsonpost = {
                    "InputData": inputarray,
                    "RouteId": this.inputDataInModalComponent != "" ? this.inputDataInModalComponent.RouteIdtry : this.routedetails.RouteIdtry,
                    "ProcessorId": this.inputDataInModalComponent != "" ? this.inputDataInModalComponent.ProcessorIdtry : this.routedetails.ProcessorIdtry,
                    "ApiKey": this.routedetails.Processorapikey,
                    "IsFileUpload": this.routedetails.isFileUpload,
                    "IsFileDownload": this.routedetails.isfiledownload,
                    "MappedXml": this.routedetails.MappedXmlTemp,
                    "Version": this.selectedVersion == ''|| this.selectedVersion == null || this.selectedVersion == undefined ? this.version : this.selectedVersion || '',
                    "isValidationFlag": this.inputDataInModalComponent ? this.inputDataInModalComponent.isValidationFlag : this.isValidationFlag
                };
                this.ngxUiLoaderService.start();
                this.service.postapi(apiname, jsonpost).then(response => {
                    this.ngxUiLoaderService.stop();
                    if (response.length == 0 || (response[0]["status"] && response[0]["statusText"])) {
                        this.toastr.error("Failed to Transform", "", {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });
                        this.FadeOuttryitoutpageMsg();
                    } else {

                        this.transformapiresponse = response as any[];
                        for (let i = 0; i < this.transformapiresponse.length; i++) {
                            if (this.transformapiresponse != null && this.transformapiresponse[i]["responsebody"] !==null ) { // this.StatusMessage = this.transformapiresponse["statusmessage"];
                                if (this.transformapiresponse.length <= 1) {
                                    this.ngxUiLoaderService.stop();
                                    this.OutputData = this.service.applyTimezoneToResponseBody(this.transformapiresponse[i]["responsebody"]);

                                    if (this.OutputData.match(/\||^[^\/<>\\].*$/)) {
                                        this.formatHL7(this.OutputData);
                                    } else { 
                                        this.formatXml(this.OutputData);
                                    }                                                                                                          
                                    // this.classObjalert = "btn alert-success ";
                                    // this.FadeOuttryitoutpageMsg();
                                    this.toastr.success(this.transformapiresponse[i]["statusmessage"], "", {
                                        timeOut: 500,
                                        positionClass: 'toast-bottom-right'
                                    });

                                    if (this.OutputData != null) {
                                        try {
                                            const previewJson = this.transformapiresponse[i]["extendedattributes"]["previewdatajson"];
                                            if (previewJson != "") {
                                                this.constructxmltree(previewJson);
                                                this.previewDataXMl = true;
                                            }
                                            const OutputJsonResponsebody = JSON.parse(this.OutputData);
                                            if (Array.isArray(OutputJsonResponsebody)) {
                                                if (OutputJsonResponsebody.length > 0) {
                                                    this.filecheck = true;
                                                    this.fileidarray = OutputJsonResponsebody;
                                                }
                                            }
                                            else {
                                                this.fileidValue = OutputJsonResponsebody["fileid"];
                                                if (this.fileidValue != null) {
                                                    this.filecheck = true;
                                                    this.senderid = this.transformapiresponse[i]["extendedattributes"]["senderagentid"];
                                                    this.hash = this.transformapiresponse[i]["extendedattributes"]["hash"];
                                                    this.transId = this.transformapiresponse[i]["extendedattributes"]["transactionid"];
                                                }
                                            }

                                        } catch { }
                                    } else {
                                        this.filecheck = false;
                                    }
                                }
                                else {
                                    if (i == (this.transformapiresponse.length - 1)) {
                                        this.downloadzipfile(this.transformapiresponse);
                                    }
                                }

                            } else {
                                this.ngxUiLoaderService.stop();
                                this.service.copyableToastError(this.transformapiresponse[i]["statusmessage"]);
                            }
                        }
                    }
                });
            }
        } else {
            this.toastr.error("Input is mandatory", "", {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
            });
        }
    }
    downloadzipfile(transformapiresponse: any[]) {
        let array = [];
        for (let i = 0; i < transformapiresponse.length; i++) {
            let output = transformapiresponse[i]["responsebody"];
            if (output.includes('fileid')) {

                let fileobj;
                if (transformapiresponse[i]["responsebody"].includes('fileid')) {
                    fileobj = JSON.parse(transformapiresponse[i]["responsebody"]);
                }
                if (fileobj != "" && Array.isArray(JSON.parse(transformapiresponse[i]["responsebody"]))) {
                    if (transformapiresponse[i]["responsebody"].length > 0) {
                        let fileidarray = JSON.parse(transformapiresponse[i]["responsebody"].toString());
                        for (let i = 0; i < fileidarray.length; i++) {
                            let fileidObj = {
                                fileid: fileidarray[i].fileid,
                                filename: fileidarray[i].filename
                            }
                            array.push(fileidObj);
                        }
                    }
                }
                else if (transformapiresponse[i]["responsebody"].includes('fileid')) {
                    let fileobjresponse = JSON.parse(transformapiresponse[i]["responsebody"]);
                    if (fileobjresponse['fileid']) {
                        array.push(fileobjresponse['fileid']);
                    }
                }
                if (i == (transformapiresponse.length - 1)) {
                    var apiname = "api/Routes/GetFileContent";
                    this.service.postapi(apiname, array).then(response => {
                        this.ngxUiLoaderService.stop();
                        let data = response as any[];
                        let fileArray = [];
                        for (let k = 0; k < data.length; k++) {
                            if (array[k].filename && array[k].filename.indexOf('.') == "-1") {
                                array[k].filename += ".txt";
                            }
                            let obj = {
                                filename: array[k].filename,
                                filecontent: data[k]["responsebody"],
                                type: 'application/octet-stream'
                            };
                            fileArray.push(obj);
                            if (k == (data.length - 1)) {
                                this.createZip(fileArray);
                            }
                        }
                    });
                }
            }
            else {
                let obj = {
                    filename: '',
                    filecontent: '',
                    type: ''
                };
                let fileArray = [];
                fileArray.push(obj);
                if (i == (transformapiresponse.length - 1)) {
                    this.createZip(fileArray);
                }
            }
        }
    }
    async createZip(files: any[]) {
        var zip = new JSZip();
        var today = new Date();

        var date = today.getFullYear()+''+(today.getMonth()+1)+''+today.getDate();

        var time = today.getHours() + "" + today.getMinutes() + "" + today.getSeconds()+today.getMilliseconds();

        var dateTime = date+time;

        const name = 'Output_' + dateTime + '.zip';
        for (let counter = 0; counter < files.length; counter++) {
            zip.file(files[counter].filename, files[counter].filecontent, { base64: true });
        };
        this.ngxUiLoaderService.stop();
        zip.generateAsync({ type: 'blob' }).then((content) => {
            if (content) {
                var FileSaver = require("file-saver");
                FileSaver.saveAs(content, name);
                this.ngxUiLoaderService.stop();
            }
        });
    }
    FadeOuttryitoutpageMsg() {
        this.statusmessagetryitout = true;
        setTimeout(() => {
            this.statusmessagetryitout = false;
        }, 20000);
    }
    clearAll() {
        this.classObjalert = "col-sm-5";
        this.OutputData = "";
        this.StatusMessage = "";
        // InputDatacontentvalue.value = '';
        this.inputdata = "";
        this.previewDataXMl = false;
        this.fileidValue = "";
        this.nestedTreeControl = new NestedTreeControl<FileNode>(this._getChildren);
        this.nestedDataSource = new MatTreeNestedDataSource();
        this.filecheck = false;
        this.notfounddata = false;
        if (!this.popupflag) {
            this.inputDataInModalComponent = [];
        }
        this.searchkey='';
    }

    copyToClip(event: any, message: any) {
        if (event != "") {
            var xmlDocument;
            try {
                xmlDocument = (new DOMParser()).parseFromString(event, 'text/xml');
            }
            catch {
                xmlDocument = "";
            }
            if (xmlDocument) {
                event = beautify(event);
            }
            copyToClipboard(event);
            // this.StatusMessage = "copied";
            // this.classObjalert = "btn alert-success ";
            // this.FadeOuttryitoutpageMsg();
            this.toastr.success(message + " Copied", "", {
                timeOut: 500,
                positionClass: 'toast-bottom-right'
            });
        }
    }

    checkedevent(e) {
        if (e.target.checked) {
            this.routedetails.isFileUpload = true;
        } else {
            this.routedetails.isFileUpload = true;
        }
    }
    checkedeventdownload(e) {
        if (e.target.checked) {
            this.routedetails.isfiledownload = true;
        } else {
            this.routedetails.isfiledownload = true;
        }
    }

    downloadfile() {
        this.ngxUiLoaderService.start();
        if (this.fileidarray.length > 0) {
            for (var i = 0; i < this.fileidarray.length; i++) {
                this.downloadcontent(this.fileidarray[i].fileid, this.fileidarray[i].filename)
            }
        }
        else {
            this.downloadcontent(this.fileidValue,"")
        }
        this.ngxUiLoaderService.stop();

    }
    downloadcontent(fileid,filename) {
     let createdBy= JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid'];
        let apiname = "api/Routes/GetFileData?fileID=" + fileid+"&contextId=" + this.routeUniqueID+"&createdBy=" + createdBy;
        (this.service.getapiurlcontent(apiname)).subscribe({
            next: data123 => {
                if (data123["statusmessage"] != "" && data123["statusmessage"] != null) {
                    var fileDetails = JSON.parse(data123["statusmessage"]);
                    //let filename = "";
                    if (fileDetails.hasOwnProperty("filename")) {
                        filename = fileDetails.filename;
                    }
                    if (filename == "") {
                        filename = fileid;
                    }

                    if (typeof (fileDetails) == "object" && fileDetails.hasOwnProperty("contenttype")) {
                        let contentType = fileDetails.contenttype;

                        switch (contentType) {
                            case "application/xml": filename += ".xml";
                                break;
                            case "application/json": filename += ".js";
                                break;
                            case "application/pdf": filename += ".pdf";
                                break;
                            default: filename += ".txt";
                                break;
                        }
                    }
                    if (filename != "" && filename.indexOf('.') == -1) {
                        filename += '.txt';
                    }
                    var xmlDocument;
                    try {
                        xmlDocument = (new DOMParser()).parseFromString(data123.responsebody, 'text/xml');
                    }
                    catch {
                        xmlDocument = "";
                    }
                    if (xmlDocument) {
                        data123.responsebody = beautify(data123.responsebody);
                    }
                    const file = new window.Blob([data123.responsebody], { type: 'application/octet-stream' });
                    const downloadAncher = document.createElement("a");
                    const fileURL = URL.createObjectURL(file);
                    downloadAncher.href = fileURL;
                    downloadAncher.download = filename;
                    downloadAncher.click();
                }
            },
            error: error => {
                this.ngxUiLoaderService.stop();
                this.toastr.error('Failed to download file', "", {
                    timeOut: 4000,
                    positionClass: 'toast-bottom-right'
                });
            }
        });
    }

    downloadfilebyFileid(isflag) {
        this.ngxUiLoaderService.start();
        if (this.fileidarray.length > 0) {
            this.backupfileArray = []
            for (var i = 0; i < this.fileidarray.length; i++) {
                this.downloadcontents(this.fileidarray[i].fileid, this.fileidarray[i].filename, isflag)
            }
        }
        else {
            //this.downloadcontents(fileId);
        }
        //this.ngxUiLoaderService.stop();
    }

    downloadcontents(fileids, filename, isflag) {
        let jsondata = {
            messagetype: this.inputDataInModalComponent != "" ? this.inputDataInModalComponent.interfacetype : this.routeMessageType,
            fileid: fileids,
            contextId: this.inputDataInModalComponent != "" ? this.inputDataInModalComponent.Uniqueid : this.routeUniqueID,
            createdBy: JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid']
        };
        this.ngxUiLoaderService.start();
        this.service.GetFileContentByFileID(jsondata).subscribe((response: any) => {
            this.ngxUiLoaderService.stop();
            if (response.length > 0) {
                this.backupfileArray = response.concat(this.backupfileArray)
                this.ngxUiLoaderService.start();
                if (this.fileidarray.length == 1 && response.length == 1 && isflag == "view") {
                    this.viewFile(response[0])
                    this.ngxUiLoaderService.stop();
                } else if (this.fileidarray.length === this.backupfileArray.length && isflag == "view") {
                    this.fileidarray.forEach(element => {
                        let uniq = this.backupfileArray.find(va => va.fileid == element.fileid)
                        uniq.filename = element.filename
                    });
                    const modalRef = this.modalService.open(ConsolidateviewfileComponent, { windowClass: "PopupScreen", backdrop: "static", keyboard: false });
                    modalRef.componentInstance.backupfileArray = this.backupfileArray;
                    this.trackModalRef(modalRef, "PopupScreen");
                    
                    modalRef.result.then(() => {
                        this.untrackModalRef(modalRef);
                    }, (reason) => {
                        this.untrackModalRef(modalRef);
                    });
                    
                    // Add data attribute to identify the modal and backdrop
                    setTimeout(() => {
                        const modalElement = document.querySelector('.modal.show') as HTMLElement;
                        if (modalElement) {
                            modalElement.setAttribute('data-tryitout-modal', 'true');
                        }
                        const backdrop = document.querySelector('.modal-backdrop.show') as HTMLElement;
                        if (backdrop) {
                            backdrop.setAttribute('data-tryitout-modal', 'true');
                        }
                    }, 100);
                    
                    this.modalWasOpen = true;
                }
                else if (isflag == "download") {
                    response.forEach(element => {
                        if (element.filecontent != null) {
                            filename = filename == "" ? element.filename : filename;
                            if (filename == "") {
                                filename = element.fileid + element.fileformat;
                            }
                            this.ngxUiLoaderService.stop();
                            this.downloadFiles(element, filename);
                        } else {
                            this.ngxUiLoaderService.stop();
                        }
                    });
                }
                this.ngxUiLoaderService.stop();
            }
            else {
                this.ngxUiLoaderService.stop();
                this.toastr.warning("File Content not available from the API", "", {
                    timeOut: 4000,
                    positionClass: 'toast-bottom-right'
                });
            }
        });
    }

    downloadFiles(data: any, filename: any) {
        if (!filename.includes(".")) {
            filename = filename + "." + data.fileformat;
        }
        var decodedContent = null;
        if (data.fileformat == "pdf") {
            this.ngxUiLoaderService.start();
            decodedContent = "data:application/pdf;base64," + data.filecontent;
            const link = document.createElement("a");
            link.href = decodedContent;
            link.download = filename;
            link.click();
            this.ngxUiLoaderService.stop();
        } else if (data.fileformat !== null) {
            this.ngxUiLoaderService.start();
            decodedContent = data.filecontent;
            let contype = "application/octet-stream";
            const file = new window.Blob([decodedContent], { type: contype });
            const downloadAncher = document.createElement("a");
            const fileURL = URL.createObjectURL(file);
            downloadAncher.href = fileURL;
            downloadAncher.download = filename;
            downloadAncher.click();
            this.ngxUiLoaderService.stop();
        }
    }

    viewFile(response) {
        this.ngxUiLoaderService.start();
        let namemodal = {
            name: this.fileidarray[0].filename,
            fullfile: response.filecontent,
            type: response.fileformat
        }
        // Use source-aware class to avoid mixing create/interface owned backdrops.
        const isCreatePopup = this.popupflag && this.popupSource === "create";
        const windowClass = isCreatePopup ? "myCustomModalViewfilehl7ViewerFromCreate" : "myCustomModalViewfilehl7Viewer";
        const modalRef = this.modalService.open(FileViewExplorerComponent
            , {
                windowClass: windowClass,
                backdrop: "static",
                keyboard: false
            });
        modalRef.componentInstance.fileData = namemodal;
        modalRef.componentInstance.fileType = response.fileformat;
        this.ngxUiLoaderService.stop();
        this.trackModalRef(modalRef, windowClass);
        
        modalRef.result.then(() => {
            this.untrackModalRef(modalRef);
        }, (reason) => {
            this.untrackModalRef(modalRef);
        });
        
        // Add data attribute to identify the modal and backdrop
        setTimeout(() => {
            const modalElement = document.querySelector(`.modal.${windowClass}`) as HTMLElement;
            if (modalElement) {
                if (isCreatePopup) {
                    modalElement.setAttribute('data-create-modal', 'true'); // If opened from create popup
                } else {
                    modalElement.setAttribute('data-tryitout-modal', 'true'); // If opened from tryitout tab
                }
            }
            const backdrops = Array.from(document.querySelectorAll('.modal-backdrop.show')) as HTMLElement[];
            const backdrop = backdrops.length > 0 ? backdrops[backdrops.length - 1] : null;
            if (backdrop) {
                if (isCreatePopup) {
                    backdrop.setAttribute('data-create-modal', 'true'); // If opened from create popup
                } else {
                    backdrop.setAttribute('data-tryitout-modal', 'true'); // If opened from tryitout tab
                }
            }
        }, 100);
        
        this.modalWasOpen = true;
    }
    
    // formatXml(xml: any) {
    //     var formatted = "";
    //     var reg = /(>)(<)(\/*)/g;
    //     xml = xml.replace(reg, "$1\r\n$2$3");
    //     var pad = 0;
    //     xml.split("\r\n").map((node: any, index: number) => {
    //         var indent = 0;
    //         if (node.match(/.+<\/\w[^>]*>$/)) {
    //             indent = 0;
    //         } else if (node.match(/^<\/\w/)) {
    //             if (pad != 0) {
    //                 pad -= 1;
    //             }
    //         } else if (node.match(/^<\w[^>]*[^\/]>.*$/)) {
    //             indent = 1;
    //         } else {
    //             indent = 0;
    //         }

    //         var padding = "";
    //         for (var i = 0; i < pad; i++) {
    //             padding += "  ";
    //         }

    //         formatted += padding + node + "\r\n";
    //         pad += indent;
    //     });
    //     this.OutputData = formatted;
    //     return this.OutputData;
    // }
    formatHL7(xml: any) {
        const lines = xml.split("\r\n");
        const formattedLines: string[] = [];
        let pad = 0;
    
        for (const line of lines) {
            const trimmedLine = line.trim();
            let indent = 0;
    
            if (trimmedLine.startsWith("</") || trimmedLine.endsWith("/>")) {
                indent = 0;
                pad = Math.max(0, pad - 1);
            } else if (trimmedLine.startsWith("<") && !trimmedLine.endsWith("/>")) {
                indent = 1;
                pad++;
            } 
    
            formattedLines.push("  ".repeat(pad) + trimmedLine);
            pad += indent;
        }
        this.OutputData = formattedLines.join("\r\n");;
        return this.OutputData;
    }

    formatXml(xml: any) {
        let formatted = "";
        let pad = 0;
    
        xml = xml.replace(/(>)(<)(\/*)/g, "$1\r\n$2$3");
        const lines = xml.split("\r\n");
    
        lines.forEach((node: any) => {
            let indent = 0;
    
            if (node.match(/.+<\/\w[^>]*>$/)) {
                indent = 0;
            } else if (node.match(/^<\/\w/)) {
                if (pad != 0) {
                    pad -= 1;
                }
            } else if (node.match(/^<\w[^>]*[^\/]>.*$/)) {
                indent = 1;
            } else {
                indent = 0;
            }
    
            const padding = "  ".repeat(pad);
            formatted += padding + node + "\r\n";
            pad += indent;
        });
        this.OutputData = formatted;
        return this.OutputData;
    }
    constructxmltree(json) {
        this.database = new FileDatabase(json);
        this.database.dataChange.subscribe((data) => (this.nestedDataSource.data = data));
    }
    isLoadingroutes: boolean = false;
    RouteNameListgbl: any = [];
    selectedrouteIdgbl: string = '';
    selectedrouteDisplayNamegbl: string = '';
    keywordsearchgbl: string = 'displayname';

    getRouteNamegbl(event: any) {
        var val = event;
        if (val) {
            this.isLoadingroutes = true;
            var apiname = "api/Routes/GetByDisplayName?name=" + val + "&version=0";
            this.service.getapiurl(apiname).subscribe({
                next: data => {
                    this.RouteNameListgbl = data as any[];
                    this.RouteNameListgbl.map(
                        obj => obj.displayname = `${obj.displayname
                            } ${'(' + obj.id + ')(VA-'+obj.UniqueID+')'
                            }`
                    );
                    this.isLoadingroutes = false;
                    if (data.length == 0) {
                        this.notfounddata = true;
                    }
                    else {
                        this.notfounddata = false;
                    }
                },
                error: error => {
                    this.isLoadingroutes = false;
                    this.notfounddata = true;
                }
            });
        }

    }


    selectedRoutegbl(item) {
        this.selectedrouteIdgbl = item.id;
        this.selectedrouteDisplayNamegbl = item.displayname;
        this.getRouteDetails();
    }
    searchRouteNameClearedgbl(event) {
        this.isLoadingroutes = false;
        this.RouteNameListgbl = [];
        this.selectedrouteIdgbl = '';
        this.selectedrouteDisplayNamegbl = '';
        this.fileUploadFTP = false;
        this.enableAccessionSearch = false;
        this.notfounddata = false;
        this.filecheck = false;
        this.fileidValue = "";
        this.notfounddata = false;
        this.routedetails = {
            RouteIdtry: "",
            ProcessorIdtry: "",
            ProcessorDisplayNametry: "",
            RouteDisplayNametry: "",
            Processorapikey: "",
            Popupflag: false,
            MappedXmlTemp: "",
            isFileUpload: false,
            isfiledownload: false,
            interfacetype: "",
            enableAccessionSearch: false,
            fileUploadFTP: false,
            sourcedeploymentkey: "",
            targetdeploymentkey: "",
            sourceaccounttype: "",
            targetaccounttype: "",
            seguid: "",
            deguid: "",
            sourceagent: "",
            sourceagentname: ""
        }
    }


    async getRouteDetails() {
        this.inputdata = "";
        this.searchkey = "";
        this.OutputData = "";
        if (this.selectedrouteIdgbl != "") {
            var url = "api/Routes/GetRouteList?id=" + this.selectedrouteIdgbl;
            this.ngxUiLoaderService.start();
            this.service.getapiurl(url).subscribe({
                next: async (data) => {
                    this.routeMessageType=data["messagetype"];
                    this.routeUniqueID=data["UniqueID"];
                    this.connectivitytype = data['Connectivity'];
                    let response: any[] = (await this.getVersionDetails(data["id"], data["PAID"]));
                    if (!response?.length) {
                        this.ngxUiLoaderService.stop();
                        this.toastr.warning('No mapping version found.', '', { timeOut: 3500, positionClass: 'toast-bottom-right' });
                        return;
                    }
                    const useLatestDevQcLive = this.service.isXmlMappingsTryItOutSource(
                        this.inputDataInModalComponent,
                        this.popupSource
                    );
                    const configToUse = useLatestDevQcLive
                        ? this.service.resolveLatestDevQcLiveConfig(response)
                        : this.service.resolveLiveConfig(response);
                    if (!configToUse) {
                        this.ngxUiLoaderService.stop();
                        this.toastr.warning(
                            useLatestDevQcLive
                                ? 'No mapping version found.'
                                : 'No live mapping version found for the route.',
                            '',
                            { timeOut: 3500, positionClass: 'toast-bottom-right' }
                        );
                        return;
                    }
                    if (configToUse["json"] != '' && configToUse["json"] != null) {
                        var jsonData;
                        var vaconfigdata;
                        var interfacetype = "";
                        jsonData = configToUse["json"];
                        this.version = configToUse["version"];
                        if (jsonData.processorconfig != undefined && jsonData.processorconfig["vaconfig"] != undefined) {
                                vaconfigdata = jsonData.processorconfig["vaconfig"];
                        }
                        if (jsonData.processorconfig != undefined && jsonData.processorconfig["interfacetype"] != undefined) {
                                interfacetype = jsonData.processorconfig["interfacetype"];
                        }
                        this.isValuefromInput = false;
                        if (data["INTERFACETYPE"] === "Inbound" || data["INTERFACETYPE"] === "EllkayInbound") {
                            this.fileUploadFTP = true;
                            this.enableAccessionSearch = false;
                        } else if (data["INTERFACETYPE"] === "Outbound" || data["INTERFACETYPE"] === "EllkayOutbound") {
                            this.fileUploadFTP = false;
                            this.enableAccessionSearch = true;
                        }
                        else {
                            this.fileUploadFTP = false;
                            this.enableAccessionSearch = false;
                        }
                        if (this.enableAccessionSearch || this.fileUploadFTP) {
                            this.screeHeightforinput = window.innerHeight - 288;
                        }

                        let isfileupload = 0;
                        let isfiledownload = 0;
                        if (vaconfigdata != undefined) {
                            isfileupload = vaconfigdata.isfileupload;
                        }

                        if (vaconfigdata != undefined) {
                            isfiledownload = vaconfigdata.isfiledownload;
                        }

                        this.routedetails = {
                            RouteIdtry: data["id"],
                            ProcessorIdtry: data["PAID"],
                            ProcessorDisplayNametry: data["PANAME"],
                            RouteDisplayNametry: data["displayname"],
                            Processorapikey: data["PAAPIKEY"],
                            Popupflag: true,
                            MappedXmlTemp: "",
                            isFileUpload: isfileupload == 0 ? false : true,
                            isfiledownload: isfiledownload == 0 ? false : true,
                            interfacetype: interfacetype,
                            enableAccessionSearch: this.enableAccessionSearch,
                            fileUploadFTP: this.fileUploadFTP,
                            sourcedeploymentkey: data["SEDEPLOYMENTKEY"],
                            targetdeploymentkey: data["DEDEPLOYMENTKEY"],
                            sourceaccounttype: data["sourcetype"],
                            targetaccounttype: data["targettype"],
                            seguid: data["SEGUID"],
                            deguid: data["DEGUID"],
                            sourceagent: data["sourceagentid"],
                            sourceagentname: data["sourceagentename"] || data["sourceagentname"] || ""
                        };
                        this.ngxUiLoaderService.stop();
                        
                    }
                    else {

                        this.ngxUiLoaderService.stop();
                        this.toastr.warning("Please check the Pipeline configurations", "", {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });
                        
                    }
                },
                error: error => {
                    this.ngxUiLoaderService.stop();
                }
            });
        }
    }

    // async getFileConfig(routeid: string, ProcessorId: string) {
    //     var dataPost = {
    //         agentid: ProcessorId,
    //         guids: routeid
    //     };

    //     return await this.service.postapi("api/CoreConfig/GetCoreConfig", dataPost);
    // }


    openFTPfilespopup() {
        const dataToFTPFilesModal = {
            routeId: this.inputDataInModalComponent == "" ? this.routedetails.RouteIdtry : this.inputDataInModalComponent.RouteIdtry,
            sourceagent: this.inputDataInModalComponent == "" ? this.routedetails.sourceagent : this.inputDataInModalComponent.sourceagent,
            name: this.inputDataInModalComponent == "" ? this.routedetails.RouteDisplayNametry : this.inputDataInModalComponent.RouteDisplayNametry,
            uniqid: this.inputDataInModalComponent == "" ? this.routeUniqueID : this.inputDataInModalComponent.Uniqueid,
            connectivitytype:this.connectivitytype,
            selectflag: true
        };
        const modalRef = this.modalService.open(FtpfilesComponent, {
            windowClass: "myCustomModalClassFTP",
            backdrop: 'static',
            keyboard: false
        });
        modalRef.componentInstance.inputDataInModalComponent = dataToFTPFilesModal;
        this.trackModalRef(modalRef, "myCustomModalClassFTP");
        
        modalRef.result.then(() => {
            this.untrackModalRef(modalRef);
        }, (reason) => {
            this.untrackModalRef(modalRef);
        });
        
        // Add data attribute to identify the modal and backdrop
        setTimeout(() => {
            const modalElement = document.querySelector('.modal.show') as HTMLElement;
            if (modalElement) {
                modalElement.setAttribute('data-tryitout-modal', 'true');
            }
            const backdrop = document.querySelector('.modal-backdrop.show') as HTMLElement;
            if (backdrop) {
                backdrop.setAttribute('data-tryitout-modal', 'true');
            }
        }, 100);
        
        this.modalWasOpen = true;
        
        modalRef.componentInstance.fileContent.subscribe((data: {filecontent: string; filename: string }) => {
            if(data.filecontent!=''){
                if (data.filecontent.startsWith('MSH|^')) {
                    this.inputdata = data.filecontent;
                    this.fileName=data.filename
                }
                else {
                    this.pdfviwerflag=true;
                    this.inputdatabackupdata=data.filecontent;
                    this.fileName=data.filename
                    this.inputdata = this._base64ToArrayBuffer(data.filecontent);
                }
            }else{
                this.toastr.warning("No data found", "", {
                    timeOut: 4000,
                    positionClass: 'toast-bottom-right'
                });
            }
          });
    }
    _base64ToArrayBuffer(base64) {
        var binary_string = base64.replace(/\\n/g, '');
        binary_string =  window.atob(base64);
        var len = binary_string.length;
        var bytes = new Uint8Array( len );
        for (var i = 0; i < len; i++)        {
            bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes.buffer;
      }

    async getVersionDetails(routeId: any, processorId: any) {
        var url = "api/CoreConfig/GetCoreconfigVersion?routeid=" + routeId + "&agentid=" + processorId + "&version=";
        const data= await firstValueFrom(this.service.getapiurl(url));
            let response: any[] = [];
            if (data) {
                response = data as any[];
                this.versionDetails = response;
                response.forEach((ele) => {
                    if (ele.version) {
                        this.versionList.push(ele.version);
                    }
                })
                this.version = this.inputDataInModalComponent.version;
                this.selectedVersion = this.version;

            }
            return response;

    }
    versionstatus:string='';
    onVersionChange(eventvalue) {
        this.versionDetails.forEach((ele) => {
            if (ele.version == eventvalue.value) {
                this.routedetails.MappedXmlTemp = ele.json.processorconfig.xslconfig.mappedxml;
                this.routedetails.isfiledownload = ele.json.processorconfig.vaconfig.isfiledownload;
                this.routedetails.isFileUpload = ele.json.processorconfig.vaconfig.isfileupload;
                this.versionstatus = ele.versionstatus;
            }
        })
    }
    openpushmessagemodel(modal,c) {
        this.dynamicJson = [];
        const routeIdForApi = this.routedetails.RouteIdtry || this.selectedrouteIdgbl || (this.inputDataInModalComponent && this.inputDataInModalComponent.RouteIdtry) || '';
        var url = "api/Routes/get?id=" + routeIdForApi;
        this.ngxUiLoaderService.start();
        this.service.getapiurl(url).subscribe(data => {
            if (data) {
                if (data["RouteProcessorData"].length > 1) {
                    // $('#pushMessage').modal({ backdrop: 'static', keyboard: false });
                    const modalRef = this.modalService.open(modal,
                        { windowClass: "pushmodal", backdrop: 'static', keyboard: false });
                    this.trackModalRef(modalRef, "pushmodal");
                    
                    modalRef.result.then(() => {
                        this.untrackModalRef(modalRef);
                    }, (reason) => {
                        this.untrackModalRef(modalRef);
                    });
                    
                    // Add data attribute to identify the modal and backdrop
                    setTimeout(() => {
                        const modalElement = document.querySelector('.modal.show') as HTMLElement;
                        if (modalElement) {
                            modalElement.setAttribute('data-tryitout-modal', 'true');
                        }
                        const backdrop = document.querySelector('.modal-backdrop.show') as HTMLElement;
                        if (backdrop) {
                            backdrop.setAttribute('data-tryitout-modal', 'true');
                        }
                    }, 100);
                    
                    this.modalWasOpen = true;
                    data["RouteProcessorData"].forEach(element => {

                        var url = "api/CoreConfig/GetCoreconfigVersion?routeid=" + routeIdForApi + "&agentid=" + element.id + "&version=";
                        this.service.getapiurl(url).subscribe(response => {
                            if (response) {
                                let version = '';
                                response.forEach((ele) => {
                                    if (ele.version) {
                                        if (ele.islive) {
                                            version = ele.version;
                                        }
                                    }
                                });
                                if (!version) {
                                    version = response[response.length - 1].version;
                                }
                                let routeprocessordata: routeprocessordata = {
                                    data: response,
                                    displayname: element.displayname,
                                    version: version,
                                    sequence: element.Sequence,
                                    processorid: element.id
                                }
                                this.dynamicJson.push(routeprocessordata);
                                if (this.dynamicJson.length > 0) {
                                    this.dynamicJson = this.sortByKey(this.dynamicJson, 'sequence')
                                }
                            }
                        }
                        )
                    }

                    );

                    this.ngxUiLoaderService.stop();
                }
                else {
                    this.pushmessage(false,c);
                    this.ngxUiLoaderService.stop();
                }
            }
        });



    }
    sortByKey(array, key) {
        return array.sort(function (a, b) {
            var x = a[key]; var y = b[key];
            return ((x < y) ? -1 : ((x > y) ? 1 : 0));
        });
    }

    pushmessage(isroutecontainsmultipleprocessor,c) {
        let routeprocessordata = [];
        let messageObj;
        const routeIdPush = this.routedetails.RouteIdtry || this.selectedrouteIdgbl || (this.inputDataInModalComponent && this.inputDataInModalComponent.RouteIdtry) || '';
        const processorIdPush = this.routedetails.ProcessorIdtry || (this.inputDataInModalComponent && this.inputDataInModalComponent.ProcessorIdtry) || '';
        if (isroutecontainsmultipleprocessor && this.dynamicJson.length > 0) {
            this.dynamicJson.forEach(ele => {
                let obj = {
                    processorAgentId: ele.processorid,
                    Sequence: ele.sequence.toString(),
                    coreConfigVersion: ele.version
                }
                routeprocessordata.push(obj);
            });
            messageObj = {
                fileName:this.fileName,
                filecontent: this.pdfviwerflag ? this.inputdatabackupdata : this.inputdata,
                routedefinitionid: routeIdPush,
                routeProcessors: this.sortByKey(routeprocessordata, 'Sequence')
            }
        }
        else {
            let obj = {
                processorAgentId: processorIdPush,
                Sequence: "1",
                coreConfigVersion: this.selectedVersion
            }
            routeprocessordata.push(obj);
            messageObj = {
                fileName:this.fileName,
                filecontent: this.inputdata,
                routedefinitionid: routeIdPush,
                routeProcessors: this.sortByKey(routeprocessordata, 'Sequence')
            }
        }
        this.ngxUiLoaderService.start();
        this.service.postapi('api/HubMessage/ReleaseMessage', messageObj).then(response => {
            if (response) {
                    this.OutputData = this.service.applyTimezoneToResponseBody(response.responsebody);
                    var obj = this.getxmldata(response.responsebody);
                    let versiontype = this.versionstatus == '101' ? ' QC' : this.versionstatus == '102' ? ' Manager' : this.versionstatus == '100' ? ' Dev' : this.versionstatus == '103' ?this.versionstatus:' Live';
                    this.service.auditsave("Add", "", ("Message Pushed Successfully for Version " + this.selectedVersion+versiontype+ " with the transactionid " + obj["transactionid"] + " and messageid " + obj["messageid"]), "Pipeline", this.routeUniqueID,'Message Pushed Successfully').then(response => {
                    this.toastr.success("Message pushed successfully", "", {
                        timeOut: 500,
                        positionClass: 'toast-bottom-right'
                    });
                            if (isroutecontainsmultipleprocessor && this.dynamicJson.length > 0) {
                                this.closepopup(c);
                            }
                    });
            }
            this.ngxUiLoaderService.stop();
        });
    }
    getxmldata(data: any) {
        var obj = {}
        if (data) {
            var xmlDocument = (new DOMParser()).parseFromString(data, 'text/xml');
            var xmlnodes = xmlDocument.childNodes[0];
            if (xmlnodes["attributes"].length > 0) {
                for (var i = 0; i < xmlnodes["attributes"].length; i++) {
                    if (xmlnodes["attributes"][i].nodeName == "transactionid") {
                        obj["transactionid"] = xmlnodes["attributes"][i].nodeValue
                    }
                    if (xmlnodes["attributes"][i].nodeName == "messageid") {
                        obj["messageid"] = xmlnodes["attributes"][i].nodeValue
                    }
                }
            }

        }
        return obj;
    }

    private isCollectSourceAgent(): boolean {
        if (this.inputDataInModalComponent && this.inputDataInModalComponent.collectsourceagentflag === true) {
            return true;
        }
        const sourceAgentName = (
            (this.inputDataInModalComponent && (this.inputDataInModalComponent.sourceagentename || this.inputDataInModalComponent.sourceagentname)) ||
            this.routedetails?.sourceagentname ||
            ''
        ).toString().toLowerCase();
        
        return sourceAgentName.includes('collect');
    }

    closepopup(c) {
        c('close modal');
        this.dynamicJson = [];
    }
    validatexml(input) {
        let isvalidxml = false;
        for (let i = 0; i < input.length; i++) {
            if (input[i].startsWith == undefined) {
                this.inputdata=this.inputdatabackupdata;
                isvalidxml = true;
            }
            else{
                if (input[i].startsWith("<")) {

                    if (this.IsValidXML(input[i])) {
                        isvalidxml = true;
                    } else {
                        isvalidxml = false;
                    }
                }
                else {
                    isvalidxml = true;
                }
            }
        }
        if (!isvalidxml) {
            this.toastr.warning("Invalid Input Xml", "", {
                timeOut: 4000,
                positionClass: "toast-bottom-right"
            });
        }
        return isvalidxml;
    }
    IsValidXML(data) {
        let xmlDocument: any;
        let isValid = false;
        try {
            xmlDocument = (new DOMParser()).parseFromString(data, 'text/xml');
            isValid = true;
        }
        catch {
            xmlDocument = "";
            isValid = false;
        }
        return isValid;
    }
    receiveMessage($event){
        this.inputdata=$event;
    }
    
    ngOnDestroy() {
        // Close all open modals when component is destroyed
        if (this.currentModalRefs && this.currentModalRefs.length > 0) {
            this.currentModalRefs.forEach(modalRef => {
                if (modalRef) {
                    try {
                        modalRef.close();
                    } catch (e) {
                        // Modal might already be closed, ignore error
                    }
                }
            });
            this.currentModalRefs = [];
            this.modalRefsTracked = [];
        }
        
        // Also close any open myCustomModalClassfileview modals opened from fileviewexplorer
        const fileViewModals = document.querySelectorAll('.modal.myCustomModalClassfileview.show') as NodeListOf<HTMLElement>;
        if (fileViewModals.length > 0) {
            fileViewModals.forEach(modalElement => {
                try {
                    // Find the close button or trigger close event
                    const closeButton = modalElement.querySelector('[data-dismiss="modal"], .close, [aria-label="Close"]') as HTMLElement;
                    if (closeButton) {
                        closeButton.click();
                    } else {
                        // Fallback: remove modal classes and backdrop
                        modalElement.classList.remove('show');
                        modalElement.style.setProperty('display', 'none', 'important');
                        const backdrop = document.querySelector('.modal-backdrop.show') as HTMLElement;
                        if (backdrop) {
                            backdrop.remove();
                        }
                        document.body.classList.remove('modal-open');
                    }
                } catch (e) {
                    // Modal might already be closed, ignore error
                }
            });
        }
        
        this.destroy$.next();
        this.destroy$.complete();
        if (this.tabChangeSubscription) {
            this.tabChangeSubscription.unsubscribe();
        }
    }
    
    private hideModals() {
        // Only hide if we have open modals tracked in currentModalRefs
        if (this.currentModalRefs && this.currentModalRefs.length > 0 && this.modalRefsTracked && this.modalRefsTracked.length > 0) {
            // Get only the windowClasses that THIS component opened
            const ownedModalClasses = this.modalRefsTracked.map(m => m.windowClass).filter(cls => cls && cls !== '');
            
            if (ownedModalClasses.length === 0) {
                return; // No modals owned by this component
            }
            
            // Find all modals with classes THIS component owns
            const selector = ownedModalClasses.map(cls => `.modal.${cls}`).join(', ');
            let modalElements = document.querySelectorAll(selector) as NodeListOf<HTMLElement>;
            
            // If not found by windowClass, try by data attribute
            if (modalElements.length === 0) {
                modalElements = document.querySelectorAll('.modal[data-tryitout-modal="true"]') as NodeListOf<HTMLElement>;
            }
            
            const backdrop = document.querySelector('.modal-backdrop.show') as HTMLElement;
            
            if (modalElements.length > 0 || backdrop) {
                this.modalWasOpen = true;
                
                // Hide all modals that belong to THIS component
                modalElements.forEach(modalElement => {
                    const hasOwnedClass = ownedModalClasses.some(className => modalElement.classList.contains(className));
                    if (hasOwnedClass) {
                        modalElement.style.setProperty('display', 'none', 'important');
                        modalElement.classList.remove('show');
                    }
                });
                
                if (backdrop) {
                    backdrop.style.setProperty('display', 'none', 'important');
                    backdrop.classList.remove('show');
                }
                
                // Also hide nested hl7viewer modals inside ftpfiles (nested modal scenario)
                let nestedHl7Modals = document.querySelectorAll('.modal.myCustomModalClassFTPHL7[data-ftpfiles-hl7viewer-modal="true"]') as NodeListOf<HTMLElement>;
                // Fallback to class name if data attribute not found
                if (nestedHl7Modals.length === 0) {
                    nestedHl7Modals = document.querySelectorAll('.modal.myCustomModalClassFTPHL7') as NodeListOf<HTMLElement>;
                }
                nestedHl7Modals.forEach(nestedModal => {
                    const nestedStyle = window.getComputedStyle(nestedModal);
                    // Only hide if it's visible and not already marked as tryitout-modal
                    if ((nestedModal.classList.contains('show') || (nestedStyle.display !== 'none' && nestedStyle.display !== '')) && 
                        !nestedModal.hasAttribute('data-tryitout-modal')) {
                        nestedModal.setAttribute('data-ftpfiles-hl7viewer-modal', 'true');
                        nestedModal.style.setProperty('display', 'none', 'important');
                        // Keep 'show' class to prevent dismissal
                    }
                });
                
                // Also hide nested fileview modals inside fileviewexplorer (nested modal scenario)
                let nestedFileViewModals = document.querySelectorAll('.modal.myCustomModalClassfileview[data-fileviewexplorer-modal="true"]') as NodeListOf<HTMLElement>;
                // Fallback to class name if data attribute not found
                if (nestedFileViewModals.length === 0) {
                    nestedFileViewModals = document.querySelectorAll('.modal.myCustomModalClassfileview') as NodeListOf<HTMLElement>;
                }
                nestedFileViewModals.forEach(nestedModal => {
                    const nestedStyle = window.getComputedStyle(nestedModal);
                    // Only hide if it's visible and not already marked as tryitout-modal
                    if ((nestedModal.classList.contains('show') || (nestedStyle.display !== 'none' && nestedStyle.display !== '')) && 
                        !nestedModal.hasAttribute('data-tryitout-modal')) {
                        nestedModal.setAttribute('data-fileviewexplorer-modal', 'true');
                        nestedModal.style.setProperty('display', 'none', 'important');
                        // Keep 'show' class to prevent dismissal
                    }
                });
                
                // Also hide nested hl7viewer modal backdrops
                const nestedHl7Backdrops = Array.from(document.querySelectorAll('.modal-backdrop')) as HTMLElement[];
                nestedHl7Backdrops.forEach(nestedBackdrop => {
                    const backdropStyle = window.getComputedStyle(nestedBackdrop);
                    // Hide if visible and not already marked as tryitout-modal (to avoid double-hiding)
                    if (backdropStyle.display !== 'none' && !nestedBackdrop.hasAttribute('data-tryitout-modal')) {
                        // Check if it's for fileviewexplorer modal
                        const modalElement = document.querySelector('.modal.myCustomModalClassfileview.show') as HTMLElement;
                        if (modalElement) {
                            nestedBackdrop.setAttribute('data-fileviewexplorer-modal', 'true');
                        } else if (!nestedBackdrop.hasAttribute('data-ftpfiles-hl7viewer-modal')) {
                            nestedBackdrop.setAttribute('data-ftpfiles-hl7viewer-modal', 'true');
                        }
                        nestedBackdrop.style.setProperty('display', 'none', 'important');
                    }
                });
                
                document.body.classList.remove('modal-open');
            }
        }
    }

    private showModals() {
        // Always hide modals with myCustomModalViewfilehl7ViewerFromCreate class (they belong to create component)
        setTimeout(() => {
            const fromCreateModals = Array.from(document.querySelectorAll('.modal.myCustomModalViewfilehl7ViewerFromCreate')) as HTMLElement[];
            fromCreateModals.forEach(modal => {
                modal.style.setProperty('display', 'none', 'important');
                modal.classList.remove('show');
            });
            const fromCreateBackdrops = Array.from(document.querySelectorAll('.modal-backdrop[data-create-modal="true"]')) as HTMLElement[];
            fromCreateBackdrops.forEach(backdrop => {
                backdrop.style.setProperty('display', 'none', 'important');
                backdrop.classList.remove('show');
            });
        }, 0);
        
        // Only show if modal was open when tab became inactive
        if (this.modalWasOpen) {
            // Use a small delay to ensure DOM is ready
            setTimeout(() => {
                // Get only the windowClasses that THIS component opened
                const ownedModalClasses = this.modalRefsTracked && this.modalRefsTracked.length > 0 
                    ? this.modalRefsTracked.map(m => m.windowClass).filter(cls => cls && cls !== '')
                    : [];
                
                if (ownedModalClasses.length === 0) {
                    this.modalWasOpen = false;
                    return; // No modals owned by this component
                }
                
                // Find modal with classes THIS component owns
                const selector = ownedModalClasses.map(cls => `.modal.${cls}`).join(', ');
                let modalElement = document.querySelector(selector) as HTMLElement;
                
                // If not found by windowClass, try by data attribute
                if (!modalElement) {
                    modalElement = document.querySelector('.modal[data-tryitout-modal="true"]') as HTMLElement;
                }
                
                if (modalElement) {
                    // Only show if it has one of the classes THIS component owns AND it's not myCustomModalViewfilehl7ViewerFromCreate
                    const hasOwnedClass = ownedModalClasses.some(className => modalElement.classList.contains(className));
                    const isFromCreate = modalElement.classList.contains('myCustomModalViewfilehl7ViewerFromCreate');
                    if (hasOwnedClass && !isFromCreate) {
                        // Show the modal again - override !important by setting with !important
                        modalElement.style.setProperty('display', 'block', 'important');
                        modalElement.classList.add('show');
                        
                        // Show all backdrops that were hidden (prefer those marked with data attribute)
                        let backdrops = Array.from(document.querySelectorAll('.modal-backdrop[data-tryitout-modal="true"]')) as HTMLElement[];
                        // Filter out create component backdrops
                        backdrops = backdrops.filter(backdrop => !backdrop.hasAttribute('data-create-modal'));
                        if (backdrops.length === 0) {
                            const allBackdrops = Array.from(document.querySelectorAll('.modal-backdrop')) as HTMLElement[];
                            backdrops = allBackdrops.filter(backdrop => !backdrop.hasAttribute('data-create-modal'));
                        }
                        
                        backdrops.forEach(backdrop => {
                            backdrop.style.setProperty('display', 'block', 'important');
                            backdrop.classList.add('show');
                        });
                        
                        // Also show nested hl7viewer modals inside ftpfiles if they were open (nested modal scenario)
                        let nestedHl7Modals = document.querySelectorAll('.modal.myCustomModalClassFTPHL7[data-ftpfiles-hl7viewer-modal="true"]') as NodeListOf<HTMLElement>;
                        // Fallback to class name if data attribute not found
                        if (nestedHl7Modals.length === 0) {
                            nestedHl7Modals = document.querySelectorAll('.modal.myCustomModalClassFTPHL7') as NodeListOf<HTMLElement>;
                        }
                        nestedHl7Modals.forEach(nestedModal => {
                            const nestedStyle = window.getComputedStyle(nestedModal);
                            // Show if it was hidden (display: none) - meaning it was open before
                            if ((nestedStyle.display === 'none' || !nestedModal.classList.contains('show')) && 
                                !nestedModal.hasAttribute('data-tryitout-modal')) {
                                nestedModal.style.setProperty('display', 'block', 'important');
                                if (!nestedModal.classList.contains('show')) {
                                    nestedModal.classList.add('show');
                                }
                            }
                        });
                        
                        // Also show nested fileview modals inside fileviewexplorer if they were open (nested modal scenario)
                        let nestedFileViewModals = document.querySelectorAll('.modal.myCustomModalClassfileview[data-fileviewexplorer-modal="true"]') as NodeListOf<HTMLElement>;
                        // Fallback to class name if data attribute not found
                        if (nestedFileViewModals.length === 0) {
                            nestedFileViewModals = document.querySelectorAll('.modal.myCustomModalClassfileview') as NodeListOf<HTMLElement>;
                        }
                        nestedFileViewModals.forEach(nestedModal => {
                            const nestedStyle = window.getComputedStyle(nestedModal);
                            // Show if it was hidden (display: none) - meaning it was open before
                            if ((nestedStyle.display === 'none' || !nestedModal.classList.contains('show')) && 
                                !nestedModal.hasAttribute('data-tryitout-modal')) {
                                nestedModal.style.setProperty('display', 'block', 'important');
                                if (!nestedModal.classList.contains('show')) {
                                    nestedModal.classList.add('show');
                                }
                            }
                        });
                        
                        // Also show nested hl7viewer modal backdrops
                        let nestedHl7Backdrops = Array.from(document.querySelectorAll('.modal-backdrop[data-ftpfiles-hl7viewer-modal="true"]')) as HTMLElement[];
                        // If no backdrops found by data attribute, find all backdrops that aren't marked as tryitout-modal
                        if (nestedHl7Backdrops.length === 0) {
                            const allBackdropsForNested = Array.from(document.querySelectorAll('.modal-backdrop')) as HTMLElement[];
                            nestedHl7Backdrops = allBackdropsForNested.filter(backdrop => !backdrop.hasAttribute('data-tryitout-modal') && !backdrop.hasAttribute('data-fileviewexplorer-modal'));
                        }
                        nestedHl7Backdrops.forEach(nestedBackdrop => {
                            const backdropStyle = window.getComputedStyle(nestedBackdrop);
                            if (backdropStyle.display === 'none') {
                                nestedBackdrop.style.setProperty('display', 'block', 'important');
                                if (!nestedBackdrop.classList.contains('show')) {
                                    nestedBackdrop.classList.add('show');
                                }
                            }
                        });
                        
                        // Also show nested fileview modal backdrops
                        let nestedFileViewBackdrops = Array.from(document.querySelectorAll('.modal-backdrop[data-fileviewexplorer-modal="true"]')) as HTMLElement[];
                        // If no backdrops found by data attribute, find all backdrops that aren't marked as tryitout-modal
                        if (nestedFileViewBackdrops.length === 0) {
                            const allBackdropsForNested = Array.from(document.querySelectorAll('.modal-backdrop')) as HTMLElement[];
                            nestedFileViewBackdrops = allBackdropsForNested.filter(backdrop => !backdrop.hasAttribute('data-tryitout-modal') && !backdrop.hasAttribute('data-ftpfiles-hl7viewer-modal'));
                        }
                        nestedFileViewBackdrops.forEach(nestedBackdrop => {
                            const backdropStyle = window.getComputedStyle(nestedBackdrop);
                            if (backdropStyle.display === 'none') {
                                nestedBackdrop.style.setProperty('display', 'block', 'important');
                                if (!nestedBackdrop.classList.contains('show')) {
                                    nestedBackdrop.classList.add('show');
                                }
                            }
                        });
                        
                        // Re-add modal-open class to body
                        document.body.classList.add('modal-open');
                        
                        // Verify modal is visible after a brief moment
                        setTimeout(() => {
                            const style = window.getComputedStyle(modalElement);
                            if (style.display === 'none' || !modalElement.classList.contains('show')) {
                                // If Bootstrap hid it again, force show it
                                modalElement.style.setProperty('display', 'block', 'important');
                                modalElement.classList.add('show');
                            }
                        }, 200);
                    }
                } else {
                    // If modal not found, reset the flag
                    this.modalWasOpen = false;
                }
            }, 150);
        }
    }
}

export class FileDatabase {
    dataChange = new BehaviorSubject<FileNode[]>([]);

    get data(): FileNode[] {
        return this.dataChange.value;
    }

    constructor(private previewDataJson: string) {
        this.initialize(this.previewDataJson);
    }

    initialize(json: string) { // Parse the string to json object.
        const dataObject = JSON.parse(json);
        delete dataObject["?xml"];
        // Build the tree nodes from Json object. The result is a list of `FileNode` with nested
        //     file node as children.
        const data = this.buildFileTree(dataObject, 0);

        // Notify the change.
        this.dataChange.next(data);
    }

    /**
   * Build the file structure tree. The `value` is the Json object, or a sub-tree of a Json object.
   * The return value is the list of `FileNode`.
   */
    buildFileTree(obj: {
        [key: string]: any
    }, level: number): FileNode[] {

        return Object.keys(obj).reduce<FileNode[]>((accumulator, key) => {
            const value = obj[key];
            const node = new FileNode();
            node.filename = key;

            if (value != null) {
                if (typeof value === "object" && value != "") {
                    node.children = this.buildFileTree(value, level + 1);
                } else {
                    node.type = value;
                }
            }

            return accumulator.concat(node);
        }, []);
    }
}

export class FileNode {
    children: FileNode[];
    filename: string;
    type: any;
}

export interface routeprocessordata {
    data: any;
    displayname: string;
    sequence: Number;
    version: string;
    processorid: string;
}
